export enum DayEndTypes {
  BySystem = 1,
  Manual = 2
}
